<template>
  <div id="container">
    <!-------------- 发货信息 -------------->
    <start-shipments-information ref="startShipmentsInformationRefs" :id="$route.query.id"></start-shipments-information>
    <div class="box-table" style="margin-top:20px">
      <div class="title-font-style">
        <span>发货清单</span>
      </div>
      <el-table
        style="margin-top:20px"
        border
        :data="list"
        tooltip-effect="dark"
        :header-cell-style="tableHeader"
        max-height="378"
      >
        <el-table-column label="合同编号" width="150" show-overflow-tooltip fixed>
          <template slot-scope="scope">
            <span class="approval" @click="toHeTong(scope.row)">{{scope.row.contractCode}}</span>
          </template>
        </el-table-column>
        <el-table-column label="客户合同编号" prop="customerContractCode" width="150"></el-table-column>
        <el-table-column label="客户名称" min-width="110" show-overflow-tooltip>
          <template slot-scope="scope">
            <div
              class="approval line-limit-length"
              @click="toKeHu(scope.row)"
            >{{scope.row.customerName}}</div>
          </template>
        </el-table-column>
        <el-table-column label="品牌" show-overflow-tooltip prop="brandName"></el-table-column>
        <el-table-column label="型号" show-overflow-tooltip>
          <template slot-scope="scope">
            <div
              class="approval line-limit-length"
              @click="onProductDetail(scope.row)"
            >{{ scope.row.proType }}</div>
          </template>
        </el-table-column>
        <el-table-column label="订货号" show-overflow-tooltip prop="orderNumber"></el-table-column>
        <el-table-column label="所在仓库" show-overflow-tooltip prop="storageName"></el-table-column>
        <el-table-column label="货期" show-overflow-tooltip>
          <template slot-scope="scope">{{scope.row.ocExtime}}天</template>
        </el-table-column>
        <el-table-column label="数量" prop="count"></el-table-column>
      </el-table>
    </div>
    <div class="footer-but">
      <el-button type="primary" @click="addDeliverGoods">发起发货</el-button>
    </div>
    <open-or-close
      @onUpdataState="contractStockup"
      :content="content"
      title="确认发货"
      ref="openOrCloseRefs"
    ></open-or-close>
  </div>
</template>
<script>
import startShipmentsInformation from './shipments/startShipmentsInformation'
import { deliverGoods, queryCustomerMsg, deliverGoodsIsProcess } from '@/api/sell/sellManage'
import OpenOrClose from '@/components/OpenOrClose/index'
export default {
  components: {
    'open-or-close': OpenOrClose,
    'start-shipments-information': startShipmentsInformation
  },
  data () {
    return {
      queryParams: {}, // 发货信息
      consigneeParams: {}, // 收货人信息
      list: this.$store.state.Sell.tempBotList,
      flag: true, // 判断是否需要审批
      content: ''
    }
  },
  mounted () {
    if (this.$store.state.Sell.tempBotList.length !== 0) {
      queryCustomerMsg(this.$route.query.id).then((res) => {
        if (res.data.code === 200) {
          this.$refs.startShipmentsInformationRefs.init(res.data.obj, 1)
        } else {
          this.$message.error(res.data.msg)
        }
      })
    } else {
      this.$router.push({ name: 'sellShipmentsRecord' })
    }
  },
  methods: {
    // 发起发货确认 往后台传数据
    contractStockup () {
      const params = {
        ...this.queryParams,
        ...this.consigneeParams,
        deliveryList: this.list
      }
      deliverGoods(this.flag, params).then((res) => {
        if (res.data.code === 200) {
          const str = this.flag
            ? '已成功发起发货'
            : '已发起发货审批, 请等待审核!'
          this.$message.success(str)
          this.$router.push({ name: 'sellShipmentsRecord' })
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    // 发起发货
    addDeliverGoods () {
      this.queryParams = this.$refs.startShipmentsInformationRefs.queryParams
      this.consigneeParams = this.$refs.startShipmentsInformationRefs.consigneeParams
      if (this.queryParams.deliverMode !== '客户自提') {
        if (
          !this.queryParams.deliverPeople ||
          !this.queryParams.deliverPhone ||
          !this.consigneeParams.receivePeople ||
          !this.consigneeParams.receivePhone
        ) {
          this.$message.error('请填写完整发货信息!')
          return
        }
      } else {
        if (!this.queryParams.expressConsignee) {
          this.$message.error('请选择提货人!')
          return
        }
        if (!this.queryParams.expressDateAd) {
          this.$message.error('请选择提货时间!')
          return
        }
      }
      deliverGoodsIsProcess(this.list).then(res => {
        if (res.data.code === 200) {
          this.flag = res.data.obj
          this.content = this.flag
            ? '发货发起后无法撤回，是否确认发货？'
            : '发货产品合同中存在不满足发货条件的合同，需提交上级审核，是否确认提交？'
          this.$refs.openOrCloseRefs.onInitial()
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    onProductDetail(row) {
      this.$router.push({ name: 'productDetails', query: { id: row.proId } })
    },
    toHeTong (row) {
      this.$router.push({
        name: 'contractEdit',
        query: { id: row.contractId, cusId: row.customerId }
      })
    },
    toKeHu (row) {
      this.$router.push({
        path: '/crm/customer/details',
        query: { id: row.customerId }
      })
    },
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    }
  }
}
</script>

<style>
</style>
